import axios from "axios";

const FALLBACK_MESSAGE = "Something went wrong. Please try again.";

export function authErrorStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

export function authErrorMessage(error: unknown): string {
  const status = authErrorStatus(error);
  if (status === 429) {
    return "Too many attempts. Please wait a minute and try again.";
  }
  if (status === undefined || (status >= 500 && status !== 503)) {
    return FALLBACK_MESSAGE;
  }

  const detail = axios.isAxiosError(error) ? error.response?.data?.detail : undefined;
  return typeof detail === "string" && detail.length > 0 ? detail : FALLBACK_MESSAGE;
}
